import { AuthState } from '@okta/okta-auth-js';

import { FuturesReferences } from '../../services/backend/FuturesReferences';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesReferences: () => FuturesReferences<AuthState> = () => {
  return useBaseApiClient(FuturesReferences);
};
